import { useEffect, useState } from "react";
import { useSearchParams } from "next/navigation";
import { QUERY_URL_PARAM } from "@/components/Search/constants";
import { useInstantSearch } from "react-instantsearch";
import {
  FilterVersion,
  ResultsHeadingVariant,
} from "@/components/Search/types";
import { useSearchIndex } from "@/components/Search/components/SearchContextProvider";
import useTranslations from "@/i18n/useTranslations";

interface SearchResultCountProps {
  resultsTitle?: string;
  filterVersion: FilterVersion;
  resultsHeadingVariant?: ResultsHeadingVariant;
}

function SearchResultCount({
  resultsTitle,
  filterVersion,
  resultsHeadingVariant = "count-with-query",
}: SearchResultCountProps) {
  const t = useTranslations("Search");
  const searchParams = useSearchParams();
  const { status, scopedResults } = useInstantSearch();
  const { searchIndex } = useSearchIndex();
  const queryParam = searchParams.get(QUERY_URL_PARAM);
  const queryResultsLabel = resultsTitle ? resultsTitle : queryParam;
  const [numberOfHits, setNumberOfHits] = useState<number>(0);

  useEffect(() => {
    const totalHits = scopedResults.reduce((sum, { indexId, results }) => {
      if (indexId === searchIndex) return sum;
      return sum + (results?._rawResults[0]?.nbHits || 0);
    }, 0);

    setNumberOfHits(totalHits);
  }, [scopedResults, searchIndex]);

  const containerClassName =
    filterVersion === FilterVersion.VerticalFilterV2 ? "mb-4" : "";
  const showQuery = resultsHeadingVariant !== "count-only";

  return (
    <div className={status !== "idle" ? "invisible" : ""}>
      <h2 className={`text-2xl ${containerClassName}`}>
        {showQuery && queryResultsLabel
          ? t("resultsCountWithQuery", {
              count: numberOfHits,
              query: queryResultsLabel,
            })
          : t("resultsCount", { count: numberOfHits })}
      </h2>
    </div>
  );
}

export default SearchResultCount;
